module.exports = __webpack_public_path__ + "cfb716fd8015030cf85bd61617472b0c.pdf";